import {loginConst} from '../constants/actionConstants';

import {sendData} from './functions';

import { createSingleAction } from '../../utils/reduxActions'

export const loginAct = createSingleAction(loginConst.GET_LOGIN_INFO);
export const loginActSuccess = createSingleAction(loginConst.GET_LOGIN_INFO_SUCCESS);

export const getTreeMenuAct = createSingleAction(loginConst.GET_MENUS_TREE);
export const getTreeMenuActSuccess = createSingleAction(loginConst.GET_MENUS_SUCCESS);



export const getMenuAct = createSingleAction(loginConst.GET_MENUS);
export const getMenuActSuccess = createSingleAction(loginConst.GET_MENUS_SUCCESS);

export const logoutAct = createSingleAction(loginConst.GET_LOGOUT);

export function pendingAct(pending) {
  return dispatch => {
    dispatch(sendData(loginConst.LOGIN_PENDING, pending))
  }
}

export function errorAct(error) {
  return dispatch => {
    dispatch(sendData(loginConst.LOGIN_ERROR, error))
  }
}

// export function resetStateAct() {
//   return dispatch => {
//     dispatch(sendData(loginConst.LOGIN_RESET_STATE, {}))
//   }
// }
export const resetStateAct = createSingleAction(loginConst.LOGIN_RESET_STATE);
